import { Component } from '@theme/component';
import { sectionRenderer } from '@theme/section-renderer';
import { RecentlyViewed } from '@theme/recently-viewed-products';

/**
 * Hydrates the "Recently Viewed Products" section with the shopper's
 * locally-stored product ids, re-rendering this section server-side against
 * Shopify's search results for those ids so the markup (and Judge.me badges,
 * pricing, etc.) matches a normal product render.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} grid
 * @extends {Component<Refs>}
 */
class RecentlyViewedWidget extends Component {
  requiredRefs = ['grid'];

  connectedCallback() {
    super.connectedCallback();
    this.#render();
  }

  async #render() {
    const sectionId = this.dataset.sectionId;
    const viewedProducts = RecentlyViewed.getProducts();

    if (!sectionId || viewedProducts.length === 0) return;

    const url = new URL(Theme.routes.search_url, window.location.origin);
    url.searchParams.set('q', viewedProducts.map((/** @type {string} */ id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');

    let html;
    try {
      html = await sectionRenderer.getSectionHTML(sectionId, false, url);
    } catch {
      return;
    }

    const newGrid = new DOMParser().parseFromString(html, 'text/html').querySelector('[ref="grid"]');

    if (!newGrid || newGrid.children.length === 0) return;

    this.refs.grid.innerHTML = newGrid.innerHTML;
    this.hidden = false;
  }
}

if (!customElements.get('recently-viewed-widget')) {
  customElements.define('recently-viewed-widget', RecentlyViewedWidget);
}
